import { useState } from "react";
import { MessageSquare, Video, Image as ImageIcon } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, emitPostsChanged } from "@/lib/api";
import { PlatformRow, VideoPlayer, ThumbImg } from "@/components/Bits";
import DecisionButtons, { DECISION_RING } from "@/components/DecisionButtons";

const MSG = { approved: "Freigegeben", pending_approval: "Zurück auf offen", rejected: "Gesperrt" };

export default function ApprovalCard({ post, file, onOpen, onChanged }) {
  const [busy, setBusy] = useState(false);
  const decide = async (status) => {
    setBusy(true);
    try { await api.post(`/posts/${post.id}/status`, { status }); toast.success(MSG[status]); onChanged?.(); emitPostsChanged(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const Icon = post.content_type === "video" ? Video : ImageIcon;
  return (
    <div className="snap-center shrink-0 w-[82vw] max-w-[340px] sm:w-80 md:w-auto md:max-w-none rounded-2xl bg-card border border-border p-3 fade-up" data-testid={`approval-card-${post.id}`}>
      <div className={`rounded-xl overflow-hidden ring-4 transition-all duration-300 ${DECISION_RING[post.status] || "ring-transparent"}`} data-testid={`approval-media-${post.id}`}>
        {file ? (file.kind === "video"
          ? <VideoPlayer file={file} className="aspect-[4/5] w-full object-cover bg-black" />
          : <ThumbImg file={file} className="aspect-[4/5] w-full object-cover" />)
          : <div className="aspect-[4/5] grid place-items-center bg-white/5 text-slate-600"><Icon className="h-10 w-10" /></div>}
      </div>
      <div className="px-1 pt-3">
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs text-slate-400">{post.scheduled_at ? new Date(post.scheduled_at).toLocaleDateString("de-DE", { weekday: "long", day: "2-digit", month: "2-digit" }) : "Ohne Termin"}</span>
          <PlatformRow platforms={post.platforms} />
        </div>
        <p className="font-semibold leading-snug mb-3 line-clamp-2">{post.title || "Ohne Titel"}</p>
        <DecisionButtons post={post} onDecide={decide} busy={busy} />
        <button onClick={() => onOpen(post)} className="mt-2 w-full h-10 rounded-lg border border-border text-sm text-slate-300 flex items-center justify-center gap-2 hover:bg-white/5" data-testid={`comment-open-${post.id}`}>
          <MessageSquare className="h-4 w-4" />Caption & Kommentare{post.comments.length > 0 && ` (${post.comments.length})`}
        </button>
      </div>
    </div>
  );
}
